import React, { lazy } from 'react';
import { PageBanner } from '../components/PageBanner';
import { MapPinIcon, PhoneIcon, ClockIcon, SendIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function ContactPage() {
  const contactInfo = [{
    icon: MapPinIcon,
    title: 'Our Location',
    details: '10632 Little Patuxent Pkwy, Suite 302, Columbia, MD 21044'
  }, {
    icon: PhoneIcon,
    title: 'Phone Number',
    details: '410-525-5285'
  }, {
    icon: ClockIcon,
    title: 'Business Hours',
    details: 'Mon-Fri: 7am - 7pm\nSat: 9am - 5pm (by appointment)'
  }];
  return <main className="bg-white" data-id="element-351">
      <PageBanner title="Contact Us" subtitle="Get in touch with our team for inquiries, appointments, or support." data-id="element-352" />

      <section className="py-24 bg-white" data-id="element-353">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-354">
          <div className="grid lg:grid-cols-2 gap-16" data-id="element-355">
            {/* Left Column - Contact Form */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-356">
              <h2 className="text-3xl font-bold text-[#1E1F55] mb-2" data-id="element-357">
                Send us a Message
              </h2>
              <p className="text-gray-600 mb-8" data-id="element-358">
                Fill out the form below and we'll get back to you as soon as
                possible.
              </p>

              <form className="space-y-6" onSubmit={e => e.preventDefault()} aria-label="Contact form" data-id="element-359">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-360">
                  <div data-id="element-361">
                    <label htmlFor="firstName" className="block text-sm font-medium text-[#1E1F55] mb-2" data-id="element-362">
                      First Name{' '}
                      <span className="text-red-500" aria-hidden="true" data-id="element-363">
                        *
                      </span>
                    </label>
                    <input type="text" id="firstName" name="firstName" required aria-required="true" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#4AA6CF] focus:ring-2 focus:ring-[#4AA6CF]/20 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="First Name" data-id="element-364" />
                  </div>
                  <div data-id="element-365">
                    <label htmlFor="lastName" className="block text-sm font-medium text-[#1E1F55] mb-2" data-id="element-366">
                      Last Name{' '}
                      <span className="text-red-500" aria-hidden="true" data-id="element-367">
                        *
                      </span>
                    </label>
                    <input type="text" id="lastName" name="lastName" required aria-required="true" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#4AA6CF] focus:ring-2 focus:ring-[#4AA6CF]/20 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Last Name" data-id="element-368" />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-369">
                  <div data-id="element-370">
                    <label htmlFor="email" className="block text-sm font-medium text-[#1E1F55] mb-2" data-id="element-371">
                      Email Address{' '}
                      <span className="text-red-500" aria-hidden="true" data-id="element-372">
                        *
                      </span>
                    </label>
                    <input type="email" id="email" name="email" required aria-required="true" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#4AA6CF] focus:ring-2 focus:ring-[#4AA6CF]/20 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="john@example.com" data-id="element-373" />
                  </div>
                  <div data-id="element-374">
                    <label htmlFor="phone" className="block text-sm font-medium text-[#1E1F55] mb-2" data-id="element-375">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" name="phone" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#4AA6CF] focus:ring-2 focus:ring-[#4AA6CF]/20 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="1-301-1234567" data-id="element-376" />
                  </div>
                </div>

                <div data-id="element-377">
                  <label htmlFor="message" className="block text-sm font-medium text-[#1E1F55] mb-2" data-id="element-378">
                    Message{' '}
                    <span className="text-red-500" aria-hidden="true" data-id="element-379">
                      *
                    </span>
                  </label>
                  <textarea id="message" name="message" rows={6} required aria-required="true" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#4AA6CF] focus:ring-2 focus:ring-[#4AA6CF]/20 outline-none transition-all bg-gray-50 focus:bg-white resize-y" placeholder="Type your message here" data-id="element-380"></textarea>
                </div>

                {/* Service Checkboxes */}
                <fieldset data-id="element-381">
                  <legend className="block text-sm font-medium text-[#1E1F55] mb-3" data-id="element-382">
                    Service
                  </legend>
                  <div className="flex flex-wrap gap-x-6 gap-y-3" data-id="element-383">
                    {[{
                    id: 'service-mobile',
                    label: 'Mobile Fingerprint'
                  }, {
                    id: 'service-background',
                    label: 'Background check'
                  }, {
                    id: 'service-inkcard',
                    label: 'Ink/Card Fingerprint'
                  }, {
                    id: 'service-livescan',
                    label: 'Livescan/Electronic Fingerprint'
                  }].map(service => <label key={service.id} htmlFor={service.id} className="flex items-center gap-2 cursor-pointer group" data-id="element-384">
                        <input type="checkbox" id={service.id} name="service" value={service.label} className="w-4 h-4 rounded border-gray-300 text-[#4AA6CF] focus:ring-[#4AA6CF]/20 cursor-pointer accent-[#4AA6CF]" data-id="element-385" />
                        <span className="text-sm text-gray-700 group-hover:text-[#1E1F55] transition-colors" data-id="element-386">
                          {service.label}
                        </span>
                      </label>)}
                  </div>
                </fieldset>

                {/* Terms and Condition */}
                <div data-id="element-387">
                  <label htmlFor="terms" className="flex items-center gap-2 cursor-pointer group" data-id="element-388">
                    <input type="checkbox" id="terms" name="terms" required aria-required="true" className="w-4 h-4 rounded border-gray-300 text-[#4AA6CF] focus:ring-[#4AA6CF]/20 cursor-pointer accent-[#4AA6CF]" data-id="element-389" />
                    <span className="text-sm text-gray-700 group-hover:text-[#1E1F55] transition-colors" data-id="element-390">
                      Terms and Condition{' '}
                      <span className="text-red-500" aria-hidden="true" data-id="element-391">
                        *
                      </span>
                    </span>
                  </label>
                </div>

                <button type="submit" className="w-full bg-[#1E1F55] hover:bg-[#2A2C6B] text-white font-semibold py-4 rounded-xl transition-colors flex items-center justify-center gap-2 shadow-lg shadow-[#1E1F55]/20" data-id="element-392">
                  <span data-id="element-393">Submit</span>
                  <SendIcon className="h-4 w-4" aria-hidden="true" data-id="element-394" />
                </button>
              </form>
            </motion.div>

            {/* Right Column - Contact Info & Map */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="flex flex-col gap-8" data-id="element-395">
              <div data-id="element-396">
                <h2 className="text-3xl font-bold text-[#1E1F55] mb-8" data-id="element-397">
                  Contact Information
                </h2>
                <div className="space-y-6" data-id="element-398">
                  {contactInfo.map((info, index) => <div key={index} className="flex items-start gap-4 p-6 bg-[#F0F4FF] rounded-2xl border border-[#E7ECF8]" data-id="element-399">
                      <div className="bg-white p-3 rounded-xl shadow-sm" data-id="element-400">
                        <info.icon className="h-6 w-6 text-[#4AA6CF]" data-id="element-401" />
                      </div>
                      <div data-id="element-402">
                        <h3 className="text-lg font-bold text-[#1E1F55] mb-1" data-id="element-403">
                          {info.title}
                        </h3>
                        <p className="text-gray-600 whitespace-pre-line leading-relaxed" data-id="element-404">
                          {info.details}
                        </p>
                      </div>
                    </div>)}
                </div>
              </div>

              {/* Embedded Map */}
              <div className="flex-grow min-h-[300px] rounded-2xl border border-gray-200 overflow-hidden" data-id="element-405">
                <iframe title="Ambient Fingerprinting Location" src="https://www.openstreetmap.org/export/embed.html?bbox=-76.8660%2C39.2000%2C-76.8560%2C39.2070&layer=mapnik&marker=39.2037%2C-76.8610" width="100%" height="100%" style={{
                border: 0,
                minHeight: '300px'
              }} loading="lazy" allowFullScreen data-id="element-406"></iframe>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </main>;
}